import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BillingTransactionsTableSkeleton = () => (
  <Styles.Container>
    <Styles.HeaderRow>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={70} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={100} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={60} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={120} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={50} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={70} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={80} height={20} />
      </Styles.HeaderCell>
      <Styles.HeaderCell>
        <Skeleton variant="text" width={50} height={20} />
      </Styles.HeaderCell>
    </Styles.HeaderRow>
    <Styles.TableBody>
      {Array.from({ length: 8 }).map((_, index) => (
        <Styles.Row key={index}>
          <Styles.Cell>
            <Skeleton variant="rounded" width={80} height={16} />
          </Styles.Cell>
          <Styles.Cell>
            <Skeleton variant="rounded" width={120} height={16} />
          </Styles.Cell>
          <Styles.Cell>
            <Skeleton variant="rounded" width={90} height={16} />
          </Styles.Cell>
          <Styles.AmountCell>
            <Skeleton variant="rounded" width={70} height={16} />
          </Styles.AmountCell>
          <Styles.AmountCell>
            <Skeleton variant="rounded" width={70} height={16} />
          </Styles.AmountCell>
          <Styles.AmountCell>
            <Skeleton variant="rounded" width={70} height={16} />
          </Styles.AmountCell>
          <Styles.AmountCell>
            <Skeleton variant="rounded" width={70} height={16} />
          </Styles.AmountCell>
          <Styles.AmountCell>
            <Skeleton variant="rounded" width={70} height={16} />
          </Styles.AmountCell>
        </Styles.Row>
      ))}
    </Styles.TableBody>
  </Styles.Container>
)

export default BillingTransactionsTableSkeleton
